import config from "../../config/domain";
import { statusUrl } from "../utils/constants";

// Session expiry (HTTP 401 / RequestResult StatusCode "-6") handling shared by
// apiService and xhrApiService, for both plain and secure (encrypted) calls.
// Several calls usually fail together when the token expires (a page fires
// Get, GetDetails, GetStatusV1, ... in parallel), so the user is told once
// and sent to the status page once; every later expired response is dropped.

const SESSION_EXPIRED_STATUS_CODE = "-6";
const DEFAULT_MESSAGE =
  "Your session has been expired.Click on ok to continue your journey.";

let redirecting = false;

export function isSessionExpired(httpStatus?: number, response?: any): boolean {
  if (httpStatus === 401) return true;
  const statusCode = response?.RequestResult?.Status?.StatusCode;
  return statusCode !== undefined && String(statusCode) === SESSION_EXPIRED_STATUS_CODE;
}

/** Parses a raw (unencrypted) response body, returning undefined if it is not JSON. */
export function parseResponseBody(text?: string | null): any {
  if (!text) return undefined;
  try {
    return JSON.parse(text);
  } catch {
    return undefined;
  }
}

/**
 * Alerts the server's message and redirects to the status page, where the
 * user re-verifies to continue. The status page itself clears
 * clientPartialDetails_ao after reading the PAN prefill, so storage is left
 * alone here; the full page load resets GlobalStore.token.
 *
 * Returns true when the session-expiry flow owns this response (the caller
 * must not run its callback), false when the response should be handled
 * normally (already on the status page, where redirecting would loop).
 */
export function handleSessionExpired(response?: any): boolean {
  if (redirecting) return true;
  if (window.location.pathname.endsWith(statusUrl.statusHome)) return false;

  redirecting = true;
  const message = response?.RequestResult?.Errors?.[0]?.ErrorMessage || DEFAULT_MESSAGE;
  alert(message);
  window.location.href = config.root + statusUrl.statusHome.replace("/", "");
  return true;
}
